module.exports = {
      id: "close-usage",
      viewBox: "0 0 512.001 512.001",
      url: __webpack_public_path__ + "svg-sprite-39ec39c5b3d32c0adb9732979a5c9627.svg#close",
      toString: function () {
        return this.url;
      }
    }